import React from 'react'
import { lineSettingsMap, LineSettingsTabs } from '../../Utils/constants';
import Tabs from '../Tabs/Tabs';

const LineSettings = () => {

    return (
        <div className="dflex flexColumn gap20 p20">
            <h1 className="pageHead">Line Settings</h1>
            <Tabs map={lineSettingsMap} tabsData={LineSettingsTabs} />
        </div>

    )
}

export default LineSettings